import PropTypes from 'prop-types';
import RegisterContainer from 'modules/general/containers/RegisterContainer';

const RegisterView = ({ mixpanel }) => <RegisterContainer mixpanel={mixpanel} />;

RegisterView.propTypes = {
  mixpanel: PropTypes.shape({}).isRequired,
};

export default RegisterView;
